
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import { type MaxCommentsCard } from '@xt/client/types/record-card'
import moment from 'moment'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class MaxCommentsCards extends Vue {
  @Prop() data: MaxCommentsCard
  @Prop({ default: true }) showRefreshBtn: boolean

  get Day() {
    return this.data.timeData ? moment(this.data.timeData).format('DD') : 0
  }

  get Month() {
    return this.data.timeData ? moment(this.data.timeData).format('MM') : 0
  }

  get Year() {
    return this.data.timeData ? moment(this.data.timeData).format('YYYY') : 0
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
